import { useCallback, useMemo } from 'react';

import { NavigationRoutingStructure } from '~/scenes/PortalViews/components/StructuredModuleRouter';
import { useAnalyticsViews } from '~/scenes/PortalViews/Views/AnalyticsViews/useAnalyticsViews';

type PropsType = {
  viewPath: string;
};

export const useAnalyticsModuleViews = (props: PropsType) => {
  const { viewPath } = props;
  const { routingStructure } = useAnalyticsViews();

  const resolveViewComponentFromStructure = useCallback(
    (
      subStructure: NavigationRoutingStructure[],
      subSegments: string[],
    ): NavigationRoutingStructure | undefined => {
      const [matchSegment, ...nextSegments] = subSegments;

      const foundNavItem = subStructure.find(
        ({ path }) => path === matchSegment,
      );

      if (!foundNavItem) {
        return undefined;
      }

      if (foundNavItem.isAvailable === false) {
        return foundNavItem;
      }

      if (!!nextSegments.length) {
        if (!!foundNavItem.subPaths) {
          return resolveViewComponentFromStructure(
            foundNavItem.subPaths,
            nextSegments,
          );
        } else {
          return undefined;
        }
      }

      return foundNavItem;
    },
    [],
  );

  const moduleView = useMemo(() => {
    const pathSegments = viewPath.split('/');

    return resolveViewComponentFromStructure(routingStructure, pathSegments);
  }, [resolveViewComponentFromStructure, routingStructure, viewPath]);

  return {
    moduleView,
  };
};
